// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3NufS","footer":"ModalFilter_footer__LmzPc"};